import React from 'react';
import { faCircleCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalBody } from 'reactstrap';
import './index.scss';

const PaymentSuccessModal = ({_modalStatus, _successRes,_handleModalStatus }) => {
    let history = useHistory();
    return (
        <Modal isOpen={_modalStatus} toggle={_handleModalStatus} className="payment-success-modal" size='sm'>
            <Button color='link' onClick={_handleModalStatus} className='modal-close-btn position-absolute'>
                <FontAwesomeIcon icon={faTimes} />
            </Button>
            <ModalBody>
                <div className='success-info text-center'>
                    <div className="row-cell">
                        <div className="icon">
                            <FontAwesomeIcon icon={faCircleCheck} />
                        </div>
                        <h2>Payment Sucessfull!</h2>
                        <h3>Subscription Number: {_successRes?.subscription_id}</h3>
                        <p>
                            <label>Amount Paid:</label>
                            <span>${_successRes?.amount}</span>
                        </p>
                    </div>
                    <div className="row-cell">
                        <Button color='primary' onClick={()=>{ history.push("/dashboard");}} >
                            Back to Home page
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default PaymentSuccessModal;